import { Button, FormField, ProgressBar } from '@cloudscape-design/components';
import Box from '@cloudscape-design/components/box';
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import Header from '@cloudscape-design/components/header';
import SpaceBetween from '@cloudscape-design/components/space-between';
import React, { useState } from 'react';
import { addNotification, buildBreadcrumbItems, formatBytes, getCookie, getUrlVersion, setData, setLoading, setParameters } from '../../../../commons/functions';
import { useGlobalState } from '../../../../context/GlobalStateContext';
import { CustomAppLayout } from '../../../layout';
const _preserve = React.version;
//import { useStoreAdmin } from '../../../context/useStoreAdmin';
import Favorites from '../../../../../components/extras/Favorites';
import MPModal from '../../../../../components/MPModal';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';

const pageSize = 20;

export const AdminProcessesSoftLandPage = () => {

    const { data, menu, parameters } = useGlobalState();

    const [progress, setProgress] = useState(0);


    const [additionalInfo, setAdditionalInfo] = useState("");
    const [sideOpen, setSideOpen] = useState(false);
    const [loadingCSV, setLoadingCSV] = useState(false);
    const [loadingXLS, setLoadingXLS] = useState(false);



    const handleRequestSoftland = async (type: string) => {
        try {
            setLoading(true)
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/admin/movements/softland/download',
                    'JWT': getCookie("JWT"),
                },
                body: JSON.stringify({
                    date: `01-${parameters.period.split("-")[1]}-${parameters.period.split("-")[0]}`,
                    type: type
                }),
            });

            if (!response.ok || !response.body) {
                throw new Error(`HTTP error: ${response.status}`);
            }

            const data = await response.json();
            if (data.code == 0) {
                handleDownloadSoftland(data.softland);

                //addNotification(data.status, "success", setData)
            } else {
                addNotification(data.status, "error", setData)
            }
        } catch (error: any) {
            addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
        } finally {
            setLoading(false)
        }
    }

    const handleDownloadSoftland = async (obj: any) => {
        window.open(`${obj.url}`)
        return;


        try {
            //setLoading(true)
            if (obj.type == "XLS")
                setLoadingXLS(true)
            if (obj.type == "CSV")
                setLoadingCSV(true)
            const response = await fetchWithWatch(`${obj.url}`, {
                method: 'GET'
            });

            if (!response.ok || !response.body) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            setProgress(0)
            const contentLength = response.headers.get('Content-Length');
            const total = contentLength ? parseInt(contentLength, 10) : 0;
            let loaded = 0;

            const reader = response.body.getReader();
            const chunks: BlobPart[] = [];

            while (true) {
                const { done, value } = await reader.read();
                if (done) break;
                if (value) {
                    chunks.push(value); // ✅ now valid
                    loaded += value.length;

                    if (total) {
                        const percent = Math.round((loaded / total) * 100);
                        setProgress(percent);
                        setAdditionalInfo(`${formatBytes(loaded)} / ${formatBytes(total)}`);
                    }
                }
            }

            const blob = new Blob(chunks);
            setProgress(0)
            setLoadingXLS(false)
            setLoadingCSV(false)
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = `SOFTLAND-${parameters.period.replace("/", ".")}.${obj.type == "XLS" ? "xls" : "csv"}`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error: any) {
            addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
        } finally {

            setProgress(0)
            setLoadingXLS(false)
            setLoadingCSV(false)
        }
    }


    return (
        <CustomAppLayout
            toolsHide
            splitPanelOpen={sideOpen}
            onSplitPanelToggle={({ detail }) => {
                setSideOpen(detail.open)
            }}

            contentType="form"
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <>
                    <SpaceBetween direction="vertical" size="m">

                        <Header
                            actions={<Favorites />}
                            description="Generación de archivo plano de carga de transacciones para Sofland"
                        >Archivo Softland</Header>

                        <SpaceBetween direction="horizontal" size="xs">
                            <FormField label="Periodo">
                                <div style={{ width: 130 }}>
                                    <MPModal
                                        width={120}
                                        today prevMonth nextMonth
                                        end={new Date()}
                                        date={`${parameters.period}`}
                                        onConfirm={(date) => {
                                            setParameters({ ...parameters, period: date.period, month: date.month, year: date.year });
                                        }}
                                    />
                                </div>
                            </FormField>
                            {parameters.period !== "" && (
                                <FormField label="&nbsp;">
                                    <Button loading={loadingXLS} onClick={() => handleRequestSoftland('XLS')}>XLS</Button>
                                </FormField>
                            )
                            }
                            {parameters.period !== "" && (
                                <FormField label="&nbsp;">
                                    <Button loading={loadingCSV} onClick={() => handleRequestSoftland('CSV')}>CSV</Button>
                                </FormField>
                            )}
                        </SpaceBetween>
                        <Box display={progress == 0 ? "none" : "block"}>
                            <ProgressBar value={progress} label="Progreso de la descarga" additionalInfo={additionalInfo} />
                        </Box>




                    </SpaceBetween>



                </>
            }
        />
    );
};
